import React from 'react';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import AgreementsList from '../LeasingComponents/AgreementsList';
// import LeaseGenerationForm from 'src/models/leasing/LeaseGenerationForm';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { SelectItem } from 'src/models/common/SelectItem';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import { AnyObject } from 'react-final-form';
import Form from 'src/components/controls/forms/Form';
import Owner from 'src/models/tract_detail/Owner';
import Lease from 'src/models/leasehold/Lease';

export interface IManageAgreementDialog {
    agreements: Array<Lease>;
    clientNumber: number;
    projectNumber: number;
    ownerLookUpId: number;
    owner: Owner;
}

export interface IManageAgreementDialogDispatchProps {
    navigate: (path: string) => void;
    incrementPage: () => void;
}

type IManageAgreementDialogPageProps = IManageAgreementDialog & IManageAgreementDialogDispatchProps;

const ManageAgreementDialog = (props: IManageAgreementDialogPageProps) => {
    const agreementTypes = () => {
        const aTypes = [{ id: 1, name: 'Lease' }];

        return aTypes.map((at) => new SelectItem(at.id, at.name));
    };

    const formSubmit = (values: AnyObject) => {
        console.log('client number', props.clientNumber, 'project number', props.projectNumber, 'ownerid', props.ownerLookUpId);
        props.navigate(
            `/clients/${props.clientNumber}/projects/${props.projectNumber}/acquisitions/lease-generation/ownerId/${props.ownerLookUpId}/leases/new-lease`
        );
    };

    return (
        <Dialog dialogName={DialogList.MANAGE_AGREEMENTS} title={`Manage KUDU Contracts - ${props.owner?.name}`}>
            <div style={{ width: '70vw' }}>
                <fieldset style={{ padding: '.3rem 0 .3rem 0', borderWidth: '1px 0 0 0' }}>
                    <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Existing Contracts</legend>
                </fieldset>

                <AgreementsList
                    pageType="ContractGeneration"
                    projectNumber={props.projectNumber}
                    clientNumber={props.clientNumber}
                    navigate={props.navigate}
                    incrementPage={props.incrementPage}
                />
            </div>
            {/* TODO: add button */}

            <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Generate Contract</legend>
            </fieldset>
            <div>
                <Form onSubmit={formSubmit}>
                    <div className="mt-1" style={{ display: 'flex' }}>
                        <div>
                            <FormSelect items={agreementTypes()} name="agreementType" label="Contract Type" />
                        </div>
                        <div className="ml-2 mt-2">
                            <Button text="Generate New Contract" intent="primary" type="submit" />
                        </div>
                    </div>
                </Form>
            </div>
        </Dialog>
    );
};

export default ManageAgreementDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ManageAgreementsDialog.tsx